// @ts-check
/* eslint-disable no-console */

import { nanoid } from 'nanoid'
// @ts-ignore
import Config from '@/config'

/**
 * @param {Error & { isAxiosError?: boolean, response?: { data: any } }} originalError
 * @returns {never}
 */
export const transformRequestFailureResponseError = originalError => {
	if (originalError.isAxiosError) {
		const error = new Error(originalError.message)
		error['id'] = originalError.response.data.id

		for (const [key, value] of Object.entries(originalError.response.data.error)) {
			error[key] = value
		}

		throw error
	}

	throw originalError
}

/**
 * @template Params
 * @template ResponseData
 * @param {import('axios').Axios} api
 * @param {string} procedureName
 * @param {boolean} checkResultPresent
 * @returns {(params: Params, options?: import('axios').AxiosRequestConfig) => Promise<ResponseData>}}
 */
export const createJsonRpc = (api, procedureName, checkResultPresent = true) => {
	return (params, config) => {
		const body = { id: nanoid(), params }
		return api.post(`/rpc/${ procedureName }`, body, config)
			.then(res => {
				const { result } = res.data

				if (Config.isLoggingEnabled) {
					console.groupCollapsed(`http POST /rpc/${ procedureName }`)
					console.log('request body', JSON.stringify(body, null, 2))
					console.log('response body', JSON.stringify(res.data, null, 2))
					console.groupEnd()
				}

				if (checkResultPresent && result == null) {
					throw new Error('Missing API Response.')
				}

				return result
			})
			.catch(transformRequestFailureResponseError)
	}
}
